// ✅ Spanish translations for the account section

const accountES = {
    comingSoon: "Próximamente",

    referralSubtitle: "Invita a otros negocios y gana recompensas",
    referralBadge: "$15 c/u",

    groups: {
        business: "Negocio",
        preferences: "Preferencias",
        account: "Cuenta",
        support: "Soporte",
    },

    roles: {
        owner: "Propietario",
        admin: "Gerente",
        staff: "Personal",
        customer: "Cliente",
    },

    menuHints: {
        billing: "Plan, facturas y créditos por referidos",
        category: "Cómo aparece tu negocio",
        bookings: "Próximas visitas y tu historial",
        language: "Idioma de la app",
        notifications: "Alertas por correo y push",
        security: "Correo, teléfono y contraseña",
        helpandsupport: "Contáctanos y lee las preguntas frecuentes",
        about: "Versión de la app e información legal",
    },

    about: {
        appName: "Sin Fila",
        version: "Versión",
        legal: "Legal",
    },

    helpAndSupport: {
        title: "Ayuda y Soporte",
        subtitle: "Respuestas a las dudas comunes y una forma de hablar con una persona.",
        contactHint: "Envíanos un mensaje — normalmente respondemos en un día",
        faqHint: "Respuestas rápidas sobre reservas, facturación y tu negocio",
        resourcesHint: "Guías para hacer crecer tu negocio en Sin Fila",
        ctaTitle: "¿Sigues atascado?",
        ctaText: "Cuéntanos qué está pasando y lo revisamos contigo.",
        ctaButton: "Contactar soporte",
    },

    menu: {
        bookings: "Citas",
        favorites: "Favoritos",
        reviews: "Reseñas",
        notifications: "Notificaciones",
        language: "Idioma",
        security: "Seguridad",
        privacy: "Política de Privacidad",
        terms: "Términos de Servicio",
        refund: "Política de Reembolso",
        contact: "Contacto",
        helpandsupport: "Ayuda y Soporte",
        reportsandperfomance: "Reportes y Rendimiento",
        marketing: "Marketing",
        category: "Categorías",
        referral: "Referidos",
        billing: "Facturación",
        logout: "Cerrar Sesión",
        about: "Acerca de"
    },

    aboutSinFila: {
        title: "Sobre Sin Fila",
        tagline: "Una empresa dominicana, creada para negocios dominicanos.",
        intro: "Sin Fila nació con una misión: ayudar a los negocios dominicanos a modernizar la forma en que gestionan sus citas y hacer crecer sus negocios. Estamos orgullosamente registrados en la República Dominicana y comprometidos con apoyar a los emprendedores locales con una tecnología diseñada alrededor de las realidades de hacer negocios aquí.",
        vision: "Nuestra visión es convertirnos en el socio tecnológico de confianza para miles de negocios dominicanos, ayudándolos a crecer, atender más clientes y avanzar hacia el futuro con confianza.",
        learnMore: "Conoce más sobre nuestra historia",
        flag: "Orgullosamente creada y registrada en la República Dominicana.",
    },

    language: {
        title: "Idioma",
        subtitle: "Elige el idioma que quieres usar en toda la app.",
        current: "Idioma actual",
        englishHint: "Inglés",
        spanishHint: "Español",
    },

    header: {
        title: "Cuenta",
        back: "Atrás",
    },

    emptyState: {
        title: "Tu Cuenta",
        description: "Selecciona una opción del menú para ver tus citas, favoritos o configuración.",
    },

    bookings: {
        title: "Citas",
        subtitle: "Tu próxima visita, lo que falta por venir y dónde has estado.",
        subtitleUpcoming: (count) => `${count} próximas`,
        nextUp: "Próxima cita",
        noUpcoming: "No tienes citas próximas",
        noOtherUpcoming: "No tienes nada más agendado después de esta",
        noHistory: "Aún no hay citas pasadas",
        signedOut: "Inicia sesión para ver tus citas.",
        historyTitle: "Historial",
        cancel: "Cancelar",
        reschedule: "Reprogramar",
        review: "Reseñar",
        confirmed: "confirmada",
        cancelled: "cancelada",
        status: {
            confirmed: "Confirmada",
            cancelled: "Cancelada",
            completed: "Completada",
            in_progress: "En progreso",
            pending: "Pendiente",
            no_show: "No asistió",
            rescheduled: "Reprogramada",
        },
        addToCalendar: "Agregar al Calendario",
        emailSent: "Correo enviado",
        confirmCancelTitle: "Cancelar cita",
        confirmCancelText: "¿Estás seguro de que deseas cancelar esta cita? Esta acción no se puede deshacer.",
        confirmCancelNo: "Mantener cita",
        confirmCancelYes: "Sí, cancelar",
    },

    favorites: {
        title: "Favoritos",
        subtitle: "Los negocios que guardaste para después.",
        empty: "Todavía no has agregado ningún favorito.",
        explore: "Explorar negocios",
    },

    reviews: {
        title: "Mis Reseñas",
        subtitle: "Todo lo que has escrito sobre los negocios que visitaste.",
        empty: "Aún no has escrito ninguna reseña.",
        rating: "Calificación",
    },

    settings: {
        title: "Cuenta y Configuración",
        comingSoon: "La configuración estará disponible pronto.",
    },

    status: {
        confirmed: "Confirmado",
        cancelled: "Cancelado",
        pending: "Pendiente",
    },

    notifications: {
        title: "Notificaciones",
        subtitle: "Elige qué te enviamos y por dónde te llega.",
        emailLabel: "Correo",
		pushLabel: "Push",
        sections: {
            bookings: "Reservas",
            reviews: "Reseñas",
            reminders: "Recordatorios",
            shop: "Negocio",
            staff: "Equipo",
        },

        items: {
            bookings: "Nuevas reservas",
            reschedule: "Reservas reprogramadas",
            cancellation: "Reservas canceladas",
            reminder24h: "24 horas antes de la reserva",
            reminder1h: "1 hora antes de la reserva",
            reviews: "Nuevas reseñas",
            shopBookings: "Nuevas reservas para mi equipo",
            shopUpdates: "Actualizaciones y anuncios del negocio",
            role_update: "Cambios de rol",
        },

        push: "Notificaciones Push",
        pushEnabled: "Las notificaciones push están activadas en este dispositivo.",
        pushCtaTitle: "Activar notificaciones push",
        pushCtaHint: "Recibe alertas en tiempo real en tu teléfono.",
    },

    categories: {
        title: "Categoría del negocio",
        subtitle: "Así te encuentran los clientes cuando exploran.",
        category: "Categoría",
        subCategory: "Subcategoría",
        select: "Seleccionar",
        current: "Apareces actualmente como",
        notSet: "Aún sin definir",
        save: "Guardar",
        saving: "Guardando…",
        saved: "Categoría actualizada",
        error: "No pudimos actualizar tu categoría. Inténtalo de nuevo.",
    },

    referral: {
        title: "Programa de Referidos",

        statusLabels: {
            pending_billing: "Esperando primer pago",
            pending_referrer_payment: "Esperando el primer pago del referidor",
            reward_issued: "Descuento aplicado ✓",
        },

        hero: {
            title: "Ahorra $15 USD por referido",
            subtitle:
                "Invita a otros negocios a Sin Fila. Cada referido activo te da $15 USD de descuento en tu próxima factura.",
            earned: (amount) => `Has ahorrado $${amount} hasta ahora`,
        },

        code: {
            label: "Tu código de referido",
            copy: "Copiar código",
        },

        link: {
            label: "Comparte tu enlace",
            copy: "Copiar enlace",
        },

        hint: "Los descuentos se aplican automáticamente cuando el negocio referido activa su facturación.",

        faqLink: "¿Preguntas sobre cómo funciona? Consulta las preguntas frecuentes",

        stats: {
            active: "Activos",
            pending: "Pendientes",
            saved: "Ahorrado",
        },

        steps: {
            title: "Cómo funciona",
            one: { title: "Comparte tu código", text: "Envía tu código o enlace a otro dueño de negocio." },
            two: { title: "Se registran", text: "Registran su negocio en Sin Fila usando tu código." },
            three: { title: "Ahorras $15", text: "Cuando activen su facturación, el descuento aparece en tu próxima factura." },
        },

        received: {
            title: "Referido que usaste",
            empty: "Aún no has usado un código de referido",
        },

        history: {
            title: "Negocios que referiste",
            empty: "Aún no tienes referidos",
            emptyHint: "Comparte tu código de arriba para empezar.",
            pending: "Pendiente",
            active: "Activo",
            rewarded: "Recompensado",
        },
    },

    faq: {
        title: "Preguntas Frecuentes",
        sectionLabel: "Programa de Referidos",
        items: [
            {
                question: "¿Cómo funciona el Programa de Referidos de Sin Fila?",
                answer:
                    "Todo negocio nuevo recibe 14 días gratis al unirse a Sin Fila. Cuando refieres a alguien usando tu código único, eso se convierte en algo mejor para ambos.",
            },
            {
                question: "¿Qué recibo si refiero un negocio?",
                answer:
                    "Una vez que el negocio que referiste haga su primer pago, recibes una recompensa de $15 USD. No hay límite — refiere tantos negocios como quieras y gana $15 USD por cada uno. Tu recompensa se aplica automáticamente a tu cuenta.",
            },
            {
                question: "¿Qué recibe la persona que referí?",
                answer:
                    "Si fuiste referido, obtienes 2 semanas extra gratis — 28 días en total en lugar de 14 — para que tengas más tiempo de probar Sin Fila antes de que se te cobre algo.",
            },
            {
                question: "¿Cómo refiero a alguien?",
                answer: "",
                list: [
                    "Encuentra tu código de referido en tu cuenta.",
                    "Compártelo con un dueño de negocio que conozcas.",
                    "Lo ingresan al registrarse (o dentro de sus primeros 14 días).",
                    "Una vez que hagan su primer pago, tu recompensa de $15 USD se agrega a tu cuenta.",
                ],
            },
            {
                question: "¿Cuándo se acredita mi recompensa?",
                answer: "Las recompensas se acreditan solo después de que tu referido haga su primer pago.",
            },
            {
                question: "¿Qué pasa si mi recompensa es mayor que mi próxima factura?",
                answer: "El saldo restante se traslada automáticamente a facturas futuras.",
            },
            {
                question: "¿Por cuánto tiempo son válidas mis recompensas de referidos?",
                answer: "Si aún no te has suscrito, las recompensas que hayas ganado siguen siendo válidas por 6 meses.",
            },
        ],
    },

    contact: {
        title: "Contactar Soporte",
        subtitle: "Cuéntanos qué pasa y te responderemos por correo.",
        responseNote: "Normalmente respondemos en un día hábil.",
        email: "Correo electrónico",
        phone: "Teléfono (opcional)",
        subject: "Asunto",
        message: "Mensaje",
        messagePlaceholder: "Tu mensaje...",
        send: "Enviar mensaje",
        sending: "Enviando...",
        success: "Mensaje enviado correctamente",
        errorRequired: "El mensaje es obligatorio",
        errorFailed: "No se pudo enviar el mensaje",
    },
    security: {
        title: "Seguridad",
        subtitle: "Administra cómo inicias sesión y cómo te contactamos.",
        dangerZone: "Zona de riesgo",

        emailTitle: "Correo electrónico",
        emailHint: "La dirección con la que inicias sesión.",
        passwordTitle: "Restablecer contraseña",

        phoneTitle: "Número de teléfono",
        phoneHint: "Se usa para avisos de reservas y para recuperar tu cuenta.",
        phoneSave: "Guardar",
        phoneSaving: "Guardando...",
        phoneSuccess: "Número de teléfono actualizado",
        phoneError: "No se pudo actualizar el número de teléfono",

        comingSoon: "La configuración de seguridad estará disponible pronto.",
    },

    forgotPassword: {
        subtitle: "Te enviaremos un correo con instrucciones para restablecer tu contraseña.",

        send: "Enviar enlace",
        sending: "Enviando...",

        success: "Correo para restablecer la contraseña enviado correctamente.",

        toast: {
            error: "No se pudo enviar el correo. Inténtalo de nuevo.",
        },
    },
};

export default accountES;
